import { render, staticRenderFns } from "./MsuAuthority.vue?vue&type=template&id=3740909a&scoped=true"
import script from "./MsuAuthority.vue?vue&type=script&lang=js"
export * from "./MsuAuthority.vue?vue&type=script&lang=js"
import style0 from "./MsuAuthority.vue?vue&type=style&index=0&id=3740909a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3740909a",
  null
  
)

export default component.exports